import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/carousel.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/customer-reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/products/product-card.component.tsx");
